var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgDepositIcon = function SvgDepositIcon(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.332,
    height: 20,
    viewBox: "0 0 21.332 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69853",
    "data-name": "Group 69853",
    transform: "translate(0 -1.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34222",
    "data-name": "Path 34222",
    d: "M27.669,16h-2a.667.667,0,1,0,0,1.334h1a.667.667,0,1,0,1.334,0v-.03a2,2,0,0,0-.334-3.973H27A.667.667,0,1,1,27,12h2a.667.667,0,1,0,0-1.334H28a.667.667,0,1,0-1.334,0v.03A2,2,0,0,0,27,14.67h.667a.667.667,0,1,1,0,1.334Z",
    transform: "translate(-16.669 -5.333)",
    fill: "#ffd45d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34223",
    "data-name": "Path 34223",
    d: "M19.333,8H17.3A6.666,6.666,0,0,0,4.033,8H2a2,2,0,0,0-2,2V20a2,2,0,0,0,2,2H19.333a2,2,0,0,0,2-2V10A2,2,0,0,0,19.333,8Zm-2.9,4a.67.67,0,0,1-.1,1.333h-.91A6.7,6.7,0,0,0,16.429,12ZM10.666,3.332A5.333,5.333,0,0,1,16,8.665a5.27,5.27,0,0,1-.557,2.37,5.333,5.333,0,0,1-2.2,2.3H8.093a5.333,5.333,0,0,1-2.2-2.3,5.27,5.27,0,0,1-.557-2.37,5.333,5.333,0,0,1,5.333-5.333ZM4.9,12a6.7,6.7,0,0,0,1,1.333H5a.669.669,0,0,1-.477-1.137A.683.683,0,0,1,4.9,12ZM20,20a.667.667,0,0,1-.667.667H2A.667.667,0,0,1,1.333,20V10A.667.667,0,0,1,2,9.331H4.033a6.516,6.516,0,0,0,.3,1.447A2,2,0,0,0,5,14.664H16.333A2,2,0,0,0,17,10.778a6.516,6.516,0,0,0,.3-1.447h2.033A.667.667,0,0,1,20,10Z",
    transform: "translate(0 0)",
    fill: "#8d8db5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_5813",
    "data-name": "Ellipse 5813",
    cx: 0.385,
    cy: 0.77,
    rx: 0.385,
    ry: 0.77,
    transform: "translate(17.7 18.16)",
    fill: "#8d8db5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5814",
    "data-name": "Ellipse 5814",
    cx: 0.77,
    cy: 0.77,
    r: 0.77,
    transform: "translate(14.623 18.16)",
    fill: "#8d8db5"
  }))));
};

export default SvgDepositIcon;